import React from 'react';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';

export default function Events() {
  const events = [
    {
      id: 1,
      title: "16th India-EU Summit",
      date: "January 27, 2026",
      location: "New Delhi, India",
      description: "Landmark event co-chaired by Indian and EU leadership, endorsing the 'Towards 2030: India-EU Joint Comprehensive Strategic Agenda' and concluding negotiations for the Free Trade Agreement (FTA).",
      image: "/images/HomeFlag.png",
      status: "Upcoming"
    },
    {
      id: 2,
      title: "Republic Day State Visit",
      date: "January 25-27, 2026",
      location: "New Delhi, India",
      description: "EU leaders visiting as Chief Guests for the 77th Republic Day celebrations, symbolizing a historic deepening of the strategic and economic partnership.",
      image: "/images/indo-euro.png",
      status: "Upcoming"
    },
    {
      id: 3,
      title: "India-EU Strategic Forum",
      date: "February 6-7, 2026",
      location: "New Delhi, India",
      description: "Inaugural Track 1.5 platform bringing together policymakers and industry leaders to foster dialogue on strategic cooperation, AI, semiconductors, and connectivity.",
      image: "/images/shared.jpg",
      status: "Upcoming"
    },
    {
      id: 4,
      title: "Trade and Technology Council (TTC) Meeting",
      date: "February 27-28, 2025",
      location: "Brussels, Belgium",
      description: "High-level ministerial meeting focusing on digital governance, resilient supply chains, and green technologies.",
      image: "/images/economic.jpg",
      status: "Past"
    }
  ];

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <div className="bg-slate-900 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: "url('/images/HomeFlag.png')" }}></div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Upcoming Events & Summits</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Stay updated with the latest bilateral meetings, forums, and strategic dialogues shaping the India-Europe economic landscape.
          </p>
        </div>
      </div>

      {/* Events List */}
      <div className="container mx-auto px-4 py-16 flex-grow">
        <div className="max-w-5xl mx-auto space-y-8">
          {events.map((event) => (
            <div key={event.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col md:flex-row border border-gray-100">
              <div className="md:w-2/5 h-64 md:h-auto relative">
                <img 
                  src={event.image} 
                  alt={event.title} 
                  className="w-full h-full object-cover" 
                  onError={(e) => { e.target.src = '/images/economic.jpg' }}
                />
                <div className="absolute top-4 left-4 bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                  {event.status}
                </div>
              </div>
              <div className="md:w-3/5 p-8 flex flex-col justify-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">{event.title}</h2>
                <div className="flex flex-wrap gap-4 mb-4 text-gray-600 text-sm">
                  <div className="flex items-center">
                    <Calendar size={16} className="mr-2 text-blue-600" />
                    {event.date}
                  </div>
                  <div className="flex items-center">
                    <MapPin size={16} className="mr-2 text-blue-600" />
                    {event.location}
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {event.description}
                </p>
                <button className="flex items-center text-blue-600 font-semibold hover:text-orange-500 transition-colors w-fit">
                  Register Interest <ArrowRight size={16} className="ml-2" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
